'use client'
import styled from 'styled-components'
import SiteHeader from './Header'

const Header = () => {
  return (
    <StyledHeader>
      <SiteHeader />
    </StyledHeader>
  )
}

// Stylin the Media, a bit strange, but only did made the sticky work well
const StyledHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
`

export default Header